module.exports = __webpack_public_path__ + "img/statistics_filled_24.f025c0fc.svg";